import React from 'react';
import styled from 'styled-components';
import {RiMore2Fill} from "react-icons/ri";

interface DropdownMenuProps {
    options: any[];
    id?: string;
    selectedOption: any;
    onSelect: (option: any) => void;
    onMoreClick?: () => void;
}

const DropdownWrapper = styled.div`
  display: flex;
  background-color: #EBEBF0;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  
`;

const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: 'Mulish', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  color: #46496f;
  background: transparent;
 
`;

const HiddenSelect = styled.select`

  background: transparent;
  border: none;
  margin: 0;
  appearance: none; /* Para navegadores modernos */
  -webkit-appearance: none; /* Safari/Chrome */
  -moz-appearance: none; /* Firefox */
  display: flex;
  align-items: center;
  padding: 6px 80px 6px 8px;

`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: 10px;
`;


const DropdownMenu: React.FC<DropdownMenuProps> = ({
                                                       options,
                                                       id = 'id',
                                                       selectedOption,
                                                       onSelect,
                                                   }) => {

    return (
        <DropdownWrapper >
            <SelectWrapper>
                <HiddenSelect
                    value={selectedOption}
                    onChange={(e) => {
                        const selected = options.find(option => option[id] === e.target.value);
                        if (selected) onSelect(selected);
                    }}
                >
                    {options.map((option, index) => (
                        <option key={index} value={option[id]}>
                            {option.label || option}
                        </option>
                    ))}
                </HiddenSelect>

                <IconContainer>
                    <RiMore2Fill size={18} color={'#555770ó'} />
                </IconContainer>

            </SelectWrapper>

        </DropdownWrapper>
    );
};

export default DropdownMenu;
